// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import stromluecke from '../../images/stromluecke.svg'
import SVG from 'react-inlinesvg'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class Chart extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }

  componentDidMount() {}

  render() {
    return <div className='chart'>
            <h3>Im Winter produziert die Schweiz zu wenig Strom</h3>
            <div className='subtitle'>Produzierte Strommenge im Vergleich zum Verbrauch, 2021, in GWh</div>
            
            <span className='legend'>
              <span className='entry'>
                <span className='swatch'>
                  <svg width='12' height='12'>
                    <line
                      x2='12'
                      y1='12'
                      y2='0'
                      stroke='#D3343F'
                      strokeWidth='4'
                    />
                  </svg>
                </span>
                <span className='label'>Verbrauch</span>
              </span>
            </span>

            <span className='legend'>
              <span className='entry'>
                <span className='swatch'>
                  <svg width='12' height='12'>
                    <rect fill='#9BC6DE' width="12" height="12" />
                  </svg>
                </span>
                <span className='label'>Wasserkraft</span>
              </span>
            </span>

            <span className='legend'>
              <span className='entry'>
                <span className='swatch'>
                  <svg width='12' height='12'>
                    <rect fill='#F1BE8D' width="12" height="12" />
                  </svg>
                </span>
                <span className='label'>Kernkraft</span>
              </span>
            </span>

            <span className='legend'>
              <span className='entry'>
                <span className='swatch'>
                  <svg width='12' height='12'>
                    <rect fill='#A3C8AF' width="12" height="12" />
                  </svg>
                </span>
                <span className='label'>Konv.-therm./erneuerbare Energie</span>
              </span>
            </span>    

            <SVG src={stromluecke} />
          </div>
  }
}
